import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleDensityMap } from "../../store/pointsSlice";
import "./DensityControl.css";

const DensityControl = () => {
    const dispatch = useDispatch();
    const showDensityMap = useSelector((state) => state.points.showDensityMap);

    return (
        <div className="density-control">
            <label className="density-toggle">
                <input
                    type="checkbox"
                    checked={showDensityMap}
                    onChange={() => dispatch(toggleDensityMap())}
                />
                Плотность распределения объектов
            </label>
            {showDensityMap && (
                <div className="density-legend">
                    <div className="density-item">
                        <span className="color-dot mining"></span>
                        <span>Отходы горнодобычи</span>
                    </div>
                    <div className="density-item">
                        <span className="color-dot alkaline"></span>
                        <span>Щелочные отходы</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DensityControl;
